import { useEffect, useState } from "react";
import ItemSelector from "./ItemSelector";
import { Link } from "react-router-dom";

export const ProductSelector = (props) => {
  const { onChange, setFieldValue } = props;

  const name = props.name || "product_id";
  const label = props.label || "Product";

  const [productSelectorOpen, setProductSelectorOpen] = useState(false);

  const [selected, setSelected] = useState([]);

  const product = selected[0];

  const handleProductSelect = (selected) => {
    setSelected(selected);

    if (onChange) {
      onChange(selected[0]);
    }

    if (setFieldValue) {
      setFieldValue(name, selected[0].id);
    }

    setProductSelectorOpen(false);
  };

  const handleOpenInNewTab = (e) => {
    e.stopPropagation();
    window.open(`/dashboard/products/${product.id}`, "_blank");
  };

  useEffect(() => {
    if (props.selected) {
      // add selected to selected as an array
      setSelected([props.selected]);
    }
  }, [props.selected]);

  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => setProductSelectorOpen(true)}
      >
        {product?.id ? (
          <Link to={"/dashboard/products/" + product?.id}>
            <label
              htmlFor="comments"
              className="block text-sm font-medium text-blue-400 cursor-pointer hover:text-blue-600"
            >
              {label}
            </label>
          </Link>
        ) : (
          <label
            htmlFor="comments"
            className="block text-sm font-medium text-gray-700"
          >
            {label}
          </label>
        )}

        {product?.id ? (
          <div className="font-bold p-2 border-b-4 border-indigo-300 flex justify-between items-center">
            <span>{product?.displayTitle}</span>
            <button
              onClick={handleOpenInNewTab}
              className="ml-2 p-1 text-gray-500 hover:text-blue-600 transition-colors"
              title="Open in new tab"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </button>
          </div>
        ) : (
          <div className="text-gray-400">Velg {label}</div>
        )}
      </div>

      <ItemSelector
        {...props}
        multiple={false}
        open={productSelectorOpen}
        selectorCloseCallback={() => setProductSelectorOpen(false)}
        selectorType="products"
        module={"product"}
        // module_param={product.id}
        selectedItems={selected}
        onSelect={(data) => handleProductSelect(data)}
        // selectedItemsCallback={handleSelectedItemsCallback}
        autoClose={true}
        compact={true}
      />
    </>
  );
};
